<template>
	<div>
		<el-row>
			<el-col :span="8">
				<el-form label-width="110px" label-position="left" style="width: 700px;">
					<el-form-item label="套餐名">
						<el-input v-model="sendData.name" size="small" style="width: 200px;"></el-input>
					</el-form-item>
					<el-form-item label="适用门店">
						<el-select multiple="" v-model="sendData.storeList" size="small" style="width: 200px;">
							<el-option-group label="营业门店" class="store">
								<el-option v-for="item in stores" :key="item.id" :value="item.id" :label="item.title">
								</el-option>
							</el-option-group>
							<el-option-group label="结业门店">
								<el-option v-for="item in storesEnd" :key="item.id" :value="item.id" :label="item.id">
								</el-option>
							</el-option-group>
						</el-select>
					</el-form-item>
					<el-form-item label="价格">
						<el-input-number v-model="sendData.price" :min="0.01" :precision="2"
							size="mini"></el-input-number>元
					</el-form-item>
					<el-form-item label="发型师审核产品">
						<el-switch v-model="sendData.workerShow" inactive-text="否" active-text="是"
							size="mini"></el-switch>
					</el-form-item>
					<el-form-item label="会员产品">
						<el-switch v-model="sendData.member" inactive-text="否" active-text="是" size="mini"></el-switch>
					</el-form-item>
					<el-form-item label="内容">
						<div v-for="(item,index) in sendData.list"
							style="display: flex;margin-bottom: 10px;margin-top: 5px;">
							<div class="wi" style="margin-right: 10px;">
								<el-select v-model="item.type" placeholder="请选择内容" clearable size="small"
									@change="clear(item)">
									<el-option v-for="ele in typeList" :key="ele.id" :value="ele.id"
										:label="ele.label"></el-option>
								</el-select>
							</div>
							<div v-if="item.type != null" style="margin-right: 10px;">
								<el-select v-if="item.type==0" v-model="item.productId" placeholder="请选择会员卡"
									size="small" clearable>
									<el-option v-for="ele in memberList" :key="ele.id" :value="ele.id"
										:label="ele.title"></el-option>
								</el-select>
								<el-select v-if="item.type==1" v-model="item.productId" placeholder="请选择次卡" size="small"
									clearable>
									<el-option v-for="ele in timeCardList" :key="ele.id" :value="ele.id"
										:label="ele.name"></el-option>
								</el-select>
								<el-select v-if="item.type==2" v-model="item.productId" placeholder="请选择权益" size="small"
									clearable>
									<el-option v-for="ele in detailList" :key="ele.id" :value="ele.id"
										:label="ele.name + ':' + ele.title"></el-option>
								</el-select>
								<el-select v-if="item.type==3" v-model="item.productId" placeholder="请选择券包" size="small"
									clearable>
									<el-option v-for="ele in packageList" :key="ele.id" :value="ele.id"
										:label="ele.name"></el-option>
								</el-select>
							</div>
							<div>
								<el-button type="danger" size="small" @click="del(index)">删除</el-button>
							</div>
						</div>
						<el-button style="color:#999; border:1px dashed; font-size:14px; padding:7px 12px;width: 120px;"
							@click="addType()">+添加内容</el-button>
					</el-form-item>

					<div class="flex" style="width: 100%;justify-content: center;">
						<el-button @click="back()">取消</el-button>
						<el-button type="primary" @click="save()">保存</el-button>
					</div>
				</el-form>
			</el-col>
			<el-col :span="16">
				<el-form label-width="80px" label-position="left" style="width: 800px;">
					<el-form-item label="缩略图">
						<span style="font-size: 14px;color: #808080;">点击上传缩略图片</span>
						<upload v-model="sendData.imgList[0].imgUrl"  class="el-tabs-pane-upload"  ref="sss"
							style="width: 200px; height: 100px;" />
					</el-form-item>
					<el-form-item label="详情图">
						<span style="font-size: 14px;color: #808080;">点击上传详情图片</span>
						<upload v-model="sendData.imgList[1].imgUrl"  class="el-tabs-pane-upload"  ref="sss"
							style="width: 200px; height: 500px;" />
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import upload from "../../compents/upload/upload";
	export default {
		components: {
			upload
		},
		data() {
			return {
				sendData: {
					id: 0,
					name: '',
					groupId: this.id,
					storeList: [],
					price: '',
					list: [{
						groupId: this.id,
						id: undefined,
						type: undefined,
						productId: undefined
					}],
					imgList: [{
							groupId: this.id,
							type: 0,
							imgUrl: ''
						},{
							groupId: this.id,
							type: 1,
							imgUrl: ''
						},
					]
				},
				typeList: [{
						id: 0,
						label: '会员卡'
					},{
						id: 1,
						label: '次卡'
					},{
						id: 2,
						label: '权益'
					},{
						id: 3,
						label: '券包'
					},
				],
				memberList: [], //会员卡列表
				timeCardList: [], //次卡列表
				detailList: [], //权益列表
				packageList: [], //券包列表
				stores: [],
				storesEnd: [],
				filter: {
					pageNum: 1, // 页码
					pageSize: 999, // 条数
					name: "", // 劵包名
					status: "", // 状态0未开始1进行中2已结束3已失效
					overdue: 0
				},
				id: 0,
				send: false
			}
		},
		mounted() {
			this.getList()
			this.getStores()
			if (this.$route.query.id != null) {
				this.id = this.$route.query.id
				this.getDetail()
			} else {
				this.$http.get("dProductGroup/getNew").then(res => {
					this.id = res.body.data
					this.init()
				})
			}
		},
		methods: {
			getDetail() {
				this.$http.get("dProductGroup/get?id=" + this.id).then(res => {
					console.log(res.body.data)
					this.sendData = res.body.data
					this.sendData.id = parseInt(this.id)
					this.sendData.groupId = parseInt(this.id)
					this.sendData.type = 0
					this.sendData.price = this.sendData.price / 100
					if (res.body.data.storeList != null) {
						if (res.body.data.storeList.length > 1) {
							let tmp = res.body.data.storeList.split(",");
							let a = []
							tmp.forEach(item => {
								a.push(parseInt(item))
							})
							this.sendData.storeList = a
						} else {
							if (res.body.data.storeList != '') {
								console.log(res.body.data.storeList)
								this.sendData.storeList.push(res.body.data.storeList)
							}
						}
					}
				})
			},
			getStores() {
				this.$http.get("store/list").then(res => {
					res.body.data.forEach(ele => {
						if (ele.businessType == 1) {
							this.storesEnd.push(ele) //结业门店
						} else {
							this.stores.push(ele) //营业门店
						}
					})
				})
			},
			save() {
				this.sendData.list.forEach(item => {
					if (item.type == undefined || item.productId == undefined) {
						this.$message.error("请填写完整内容")
						this.send = false
					} else {
						this.send = true
					}
				})
				if (this.send) {
					console.log(this.sendData)
					if (this.sendData.storeList != null && this.sendData.storeList != '') {
						if (this.sendData.storeList.length == 1) {
							this.sendData.storeList = this.sendData.storeList[0]
						}
						if (this.sendData.storeList.length > 1) {
							this.sendData.storeList = this.sendData.storeList.join(",")
						}
					} else {
						this.sendData.storeList = null
					}
					this.sendData.price = this.sendData.price * 100
					this.$http.post("dProductGroup/save", JSON.stringify(this.sendData)).then(res => {
						if (res.body.code == 200) {
							this.$router.push("productGroup")
							this.$message.success("保存成功")
						}
					})
				}
			},
			addType() {
				var a = {
					id: undefined,
					type: undefined,
					groupId: this.id,
					productId: undefined
				}
				this.sendData.list.push(a)
				console.log(this.sendData)
			},
			del(index) {
				this.sendData.list.splice(index, 1);
			},
			clear(item) {
				item.productId = undefined
			},
			getList() {
				this.$http.get("member/listMember").then(res => {
					this.memberList = res.body.data
					// console.log(this.memberList)
				})
				this.$http.get("dTimesCard/list").then(res => {
					this.timeCardList = res.body.data
					// console.log(this.timeCardList)
				})
				this.$http.get("member/detail").then(res => {
					this.detailList = res.body.data;
					// console.log(this.detailList)
				})
				this.$http.post("couponPackage/findDCouponPackage", JSON.stringify(this.filter)).then(res => {
					this.packageList = res.body.data
					// console.log(this.packageList)
				})
			},
			init() {
				this.sendData = {
					id: 0,
					name: '',
					groupId: this.id,
					storeList: [],
					price: '',
					list: [{
						groupId: this.id,
						id: undefined,
						type: undefined,
						productId: undefined
					}],
					imgList: [{
							groupId: this.id,
							type: 0,
							imgUrl: ''
						},{
							groupId: this.id,
							type: 1,
							imgUrl: ''
						},
					]
				}
			},
			back() {
				this.$router.go(-1)
			},
		}
	}
</script>

<style>
	.wi {
		width: 120px;
	}
</style>